import numeral from 'numeral';

export function formatCurrency(value) {
    return numeral(value).format('$0,0.00');
}

export function isLastItem(items, index) {
    return index === items.length - 1;
}

/**
 * Formats a number to a float string.
 * @param {Number} value
 * @param {Number} decimalPlaces
 * @returns String
 */
export function formatFloat(value, decimalPlaces = 2) {
    if (!value) return value;
    return parseFloat(value).toFixed(decimalPlaces);
}

export function replaceArray(array, newArray) {
    return array.splice(0, array.length, ...newArray);
}

export function formatPercentage(value) {
    return numeral(value / 100).format('0.00%');
}
